import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { SecurityCodeForm } from '@app/components/auth/VerificarCuentaForm/VerificarCuentaForm';

const ConfirmarRegistroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Confirmar registro')}</PageTitle>
      <SecurityCodeForm />
    </>
  );
};

export default ConfirmarRegistroPage;
